// Socket Mobile scanner S740 takes 650ms to input an EAN13 barcode
export const SCAN_TIMEOUT_DELAY = 700;
// Minimum barcode length to be considered a valid scan
export const MIN_BARCODE_LENGTH = 6;
// All except Enter key
export const NON_CHARACTER_KEYS = [
  'Shift',
  'Control',
  'Alt',
  'Meta',
  'CapsLock',
  'Tab',
  'Escape',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Backspace',
  'Delete',
  'Home',
  'End',
  'PageUp',
  'PageDown',
  'Insert',
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'F6',
  'F7',
  'F8',
  'F9',
  'F10',
  'F11',
  'F12',
  'ContextMenu',
];

/**
 * Barcode scan detection for Web
 * Triggered when a series of at least MIN_BARCODE_LENGTH characters
 * are pressed in quick succession (SCAN_TIMEOUT_DELAYms) followed by the Enter key.
 */
export const ScanKeyboardDetectionFactory = (onBarcodeScan: (barcode: string) => void) => {
  let scanTimeout: NodeJS.Timeout | null = null;
  let chars: string[] | null = null;

  const resetScanCapture = () => {
    chars = null;
    if (scanTimeout) {
      clearTimeout(scanTimeout);
      scanTimeout = null;
    }
  };

  const scanKeydownEvent = (event: JQuery.KeyDownEvent) => {
    if (NON_CHARACTER_KEYS.includes(event.key)) {
      return;
    }

    if (!chars) chars = [];
    if (!scanTimeout) {
      scanTimeout = setTimeout(() => {
        resetScanCapture();
      }, SCAN_TIMEOUT_DELAY);
    }

    if (event.key === 'Enter') {
      if (chars.length >= MIN_BARCODE_LENGTH) {
        event.preventDefault(); // onBarcodeScanned will trigger the enter key event if needed
        const barcode = chars.join('');
        onBarcodeScan(barcode);
      }
      resetScanCapture();
      return;
    }

    chars.push(event.key);
  };

  const start = () => {
    $(window).on('keydown', scanKeydownEvent);
  };
  const stop = () => {
    $(window).off('keydown', scanKeydownEvent);
    resetScanCapture();
  };

  return {
    start,
    stop,
  };
};
